import { useAdmin, usePermissions } from '@/utils/hooks'
import { PERMISSIONS } from '@/utils/permissions'
import type { ApproveWorkPeriodNode } from './types.graphql'

export const useWorkPeriodApprovePermissions = () => {
  const { hasPermissions } = usePermissions()
  const admin = useAdmin()
  const canConfirmOthers = hasPermissions(
    [
      PERMISSIONS.workPeriod.view.othersworkperiod,
      PERMISSIONS.workPeriod.approve.workperiod,
      PERMISSIONS.workPeriod.change.workperiod,
    ],
    true
  )

  function workPeriodApprovalState(
    meId: string,
    workPeriod: ApproveWorkPeriodNode
  ) {
    const isManager = meId !== workPeriod.user.id && canConfirmOthers
    const driverApproveDirty =
      workPeriod.approvedByUser || workPeriod.userComment
    const managerApproveDirty =
      workPeriod.approvedByManager || workPeriod.managerComment

    const canApproveAsDriver =
      (meId === workPeriod.user.id || admin) && !workPeriod.approvedByManager
    const canApproveAsManager =
      isManager && (workPeriod.approvedByUser || workPeriod.approvedByManager)
    return {
      driverApproveDirty,
      managerApproveDirty,
      canApproveAsDriver,
      canApproveAsManager,
    }
  }

  return { canConfirmOthers, workPeriodApprovalState }
}
